module.exports = __webpack_public_path__ + "static/media/front_sided_power_btn_focus.c705554d.png";